import React from 'react'
import { ImPower } from "@react-icons/all-files/im/ImPower";
import { MdGroup } from "@react-icons/all-files/md/MdGroup";
import { FaStar } from "@react-icons/all-files/fa/FaStar";
import { FaRegCalendarAlt } from "@react-icons/all-files/fa/FaRegCalendarAlt";
import { FaArrowsAltH } from "@react-icons/all-files/fa/FaArrowsAltH";
import { FaMicrophoneAlt } from "@react-icons/all-files/fa/FaMicrophoneAlt";
import { AiOutlineFullscreen } from "@react-icons/all-files/ai/AiOutlineFullscreen";
import { AiOutlineColumnHeight } from "@react-icons/all-files/ai/AiOutlineColumnHeight";
import { MdFullscreen } from "@react-icons/all-files/md/MdFullscreen";
import { AiOutlineSound } from '@react-icons/all-files/ai/AiOutlineSound';

let graphs = {
    Wattage: ['darkSlateBlue', <ImPower key='bolt' style={{color: 'darkSlateBlue'}} />],
    Lumens: ['darkSlateBlue', <ImPower key='bolt' style={{color: 'darkSlateBlue'}} />],
    "Screen Type": ['darkSlateBlue', <MdFullscreen key='bolt' style={{color: 'darkSlateBlue'}} />],
    Pitch: ['darkSlateBlue', <FaArrowsAltH key='bolt' style={{color: 'darkSlateBlue'}} />],
    Height: ['darkSlateBlue', <AiOutlineColumnHeight key='bolt' style={{color: 'darkSlateBlue'}} />],
    Length: ['darkSlateBlue', <AiOutlineColumnHeight key='bolt' style={{color: 'darkSlateBlue'}} />],
    Resolution: ['green', <MdFullscreen key='bolt' style={{color: 'green'}} />],
    'Event Size': ['green', <MdGroup key='group' style={{color: 'green'}}  />],
    'Capacity': ['green', <MdGroup key='group' style={{color: 'green'}}  />],
    'Speakers': ['green', <AiOutlineSound key='group' style={{color: 'green'}}  />],
    'Area': ['darkGoldenRod', <AiOutlineFullscreen key='group' style={{color: 'darkGoldenRod'}}  />],
    'Screen Size': ['darkGoldenRod', <AiOutlineFullscreen key='group' style={{color: 'darkGoldenRod'}}  />],
    'Microphones': ['darkSlateBlue', <FaMicrophoneAlt key='group' style={{color: 'darkSlateBlue'}}  />],
    'Mic Type': ['green', <FaMicrophoneAlt key='group' style={{color: 'green'}}  />],
    'Throw Distance': ['darkGoldenRod', <FaArrowsAltH key='group' style={{color: 'darkGoldenRod'}}  />],
    'Sound Quality': ['darkGoldenRod', <FaStar key='quality' style={{color: 'darkGoldenRod'}}  />],
    'Release Year': ['green', <FaRegCalendarAlt key='quality' style={{color: 'green'}}  />],
    'DJ Level': ['darkGoldenRod', <FaStar key='quality' style={{color: 'darkGoldenRod'}}  />],
}

const Snippets = ({snippets}) => {


  return <div className='prodSnippets'>
    {Object.keys(graphs).filter(k => snippets?.some(s=> s.includes(k))).map((k, i) => {
        let s = snippets.find(sni => sni.includes(k))
        let [name, metric] = s.split('//')

        return <div key={i} className="snippet" style={{border: `2px solid ${graphs[k][0]}`}}>
            <div className="icon">
                {graphs[k][1]}
            </div>
            <div className='back' style={{backgroundColor: `${graphs[k][0]}`}}></div>
            <div className="col">
                <span className="name">
                    {name}
                </span>
                <strong className="metric">
                    {metric}
                </strong>
            </div>
        </div>
    })}
  </div>
}

export default Snippets